/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// project = "TO" AND created >= "-28d" ORDER BY created DESC

import { createResource, type RouteResource } from '@atlassian/react-resource-router';

export const servicedeskKnowledgeBaseFetchProjectIssuesResource: RouteResource<{
	count: number;
}> = createResource({
	type: 'SERVICEDESK_KNOWLEDGE_BASE_FETCH_PROJECT_ISSUES',
	getKey: ({ match }) => match.query.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-knowledge-base-fetch-project-issues", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-fetch-project-issues" */ './fetchProjectIssues.tsx'
		),
});
